/**
 * GET: Retrieves the metadata for send temporary password endpoint
 * @summary tenants/{tenant}/accounts/sendTemporaryPasswordMetadata
 */
export var getTenantAccountsSendTemporaryPasswordMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/accounts/sendTemporaryPasswordMetadata"), method: 'get' }, options);
};
/**
 * GET: Localization for AddressForm application
 * @summary tenants/{tenant}/applications/addressForm/localization
 */
export var getTenantApplicationsAddressFormLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/addressForm/localization"), method: 'get' }, options);
};
/**
 * GET: Localization for Adverse Reaction SPA
 * @summary tenants/{tenant}/applications/adverseReaction/localization
 */
export var getTenantApplicationsAdverseReactionLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/adverseReaction/localization"), method: 'get' }, options);
};
/**
 * GET: Get partial set of products - returned limited number of products.
 * @summary tenants/{tenant}/applications/adverseReaction/productsPartialSet
 */
export var getTenantApplicationsAdverseReactionProductsPartialSet = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/adverseReaction/productsPartialSet"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Get availability of product
 * @summary tenants/{tenant}/products/{productCode}/availability
 */
export var getTenantProductAvailability = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/availability"), method: 'get', params: params }, options);
};
/**
 * GET: Provides information about concept availability
 * @summary tenants/{tenant}/concepts/{conceptCode}/availability
 */
export var getTenantConceptAvailability = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/availability"), method: 'get', params: params }, options);
};
/**
 * GET - returns back in stock notification availability for each of requested products.
 * @summary tenants/{tenant}/backInStockNotifications
 */
export var getTenantBackInStockNotifications = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/backInStockNotifications"), method: 'get', params: params }, options);
};
/**
 * GET - returns Configuration properties for BackInStock Notifications.
 * @summary tenants/{tenant}/backInStockNotificationsConfiguration
 */
export var getTenantBackInStockNotificationsConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/backInStockNotificationsConfiguration"), method: 'get', params: params }, options);
};
/**
 * GET - Bazaar Voice Api Controller
 * @summary tenants/{tenant}/bazaarvoice/configuration
 */
export var getTenantBazaarvoiceConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/bazaarvoice/configuration"), method: 'get', params: params }, options);
};
/**
 * Get beauty reward points localization
 * @summary beautyRewardPoints/tenants/{tenant}/localization
 */
export var getBeautyRewardPointsTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/beautyRewardPoints/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * Get all brands, optionally filtered by given category
 * @summary tenants/{tenant}/brands
 */
export var getTenantBrands = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/brands"), method: 'get', params: params }, options);
};
/**
 * Gets brand by brand id
 * @summary tenants/{tenant}/brands/{brandId}
 */
export var getTenantBrand = function (client, tenant, brandId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/brands/").concat(brandId), method: 'get', params: params }, options);
};
/**
 * Provides link to a single brand.
 * @summary tenants/{tenant}/brands/{brandId}/dynamiclink
 */
export var getTenantBrandDynamiclink = function (client, tenant, brandId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/brands/").concat(brandId, "/dynamiclink"), method: 'get', params: params }, options);
};
/**
 * Get Breadcrumbs links.
 * @summary tenants/{tenant}/applications/breadcrumb/links
 */
export var getTenantApplicationsBreadcrumbLinks = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/breadcrumb/links"), method: 'get', params: params }, options);
};
/**
 * Returns BCM incentives configuration (images, youtube ID...)
 * @summary tenants/{tenant}/businessModels/bcm/incentivesConfiguration
 */
export var getTenantBusinessModelsBcmIncentivesConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/businessModels/bcm/incentivesConfiguration"), method: 'get' }, options);
};
/**
 * Get Rewards Shop configurations
 * @summary tenants/{tenant}/rewardShopConfigurations
 */
export var getTenantRewardShopConfigurations = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/rewardShopConfigurations"), method: 'get', params: params }, options);
};
/**
 * GET - returns configuration for Catalogue IPaper
 * @summary tenants/{tenant}/applications/catalogueIPaper/configuration
 */
export var getTenantApplicationsCatalogueIPaperConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/catalogueIPaper/configuration"), method: 'get', params: params }, options);
};
/**
 * GET - returns collection of available catalogues for iPaper platform.
 * @summary tenants/{tenant}/applications/catalogueOverview
 */
export var getTenantApplicationsCatalogueOverview = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/catalogueOverview"), method: 'get', params: params }, options);
};
/**
 * GET: Provide catalogues related to the period
 * @summary tenants/{tenant}/catalogues
 */
export var getTenantCatalogues = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/catalogues"), method: 'get', params: params }, options);
};
/**
 * Provides link to the current digital catalogue.
 * @summary tenants/{tenant}/catalogues/{catalogueId}/dynamiclink
 */
export var getTenantCatalogueDynamiclink = function (client, tenant, catalogueId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/catalogues/").concat(catalogueId, "/dynamiclink"), method: 'get', params: params }, options);
};
/**
 * Provides link to the current digital catalogue.
 * @summary tenants/{tenant}/digitalCatalogue/dynamiclink
 */
export var getTenantDigitalCatalogueDynamiclink = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/digitalCatalogue/dynamiclink"), method: 'get', params: params }, options);
};
/**
 * Get social media library category by categoryId.
 * @summary tenants/{tenant}/socialMediaLibrary/categories/{categoryId}
 */
export var getTenantSocialMediaLibraryCategory = function (client, tenant, categoryId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/socialMediaLibrary/categories/").concat(categoryId),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Get social media library categories.
 * @summary tenants/{tenant}/socialMediaLibrary/categories
 */
export var getTenantSocialMediaLibraryCategories = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/socialMediaLibrary/categories"), method: 'get', params: params }, options);
};
/**
 * Get all categories
 * @summary tenants/{tenant}/categories
 */
export var getTenantCategories = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/categories"), method: 'get', params: params }, options);
};
/**
 * Returns Chat bot metadata
 * @summary tenants/{tenant}/applications/chatBot/metadata
 */
export var getTenantApplicationsChatBotMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/chatBot/metadata"), method: 'get' }, options);
};
/**
 * Returns Chat bot page metadata
 * @summary tenants/{tenant}/applications/chatBot/pageMetadata
 */
export var getTenantApplicationsChatBotPageMetadata = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/chatBot/pageMetadata"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for Checkout registration application
 * @summary tenants/{tenant}/applications/checkoutRegistration/localization
 */
export var getTenantApplicationsCheckoutRegistrationLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/checkoutRegistration/localization"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Provides information about commission plan type for the market in the specified period. If the period is not specified, the current period is used.
 * @summary tenants/{tenant}/commissionPlanType
 */
export var getTenantCommissionPlanType = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/commissionPlanType"), method: 'get', params: params }, options);
};
/**
 * Gets calculated attributes for concepts from product index.
 * @summary tenants/{tenant}/conceptIndexItems
 */
export var getTenantConceptIndexItems = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/conceptIndexItems"), method: 'get', params: params }, options);
};
/**
 * Gets collection of concept labels for anonymous customer.
 * @summary tenants/{tenant}/conceptLabels
 */
export var getTenantConceptLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/conceptLabels"), method: 'get', params: params }, options);
};
/**
 * GET: Provides concept
 * @summary tenants/{tenant}/deprecatedConcepts/{conceptCode}
 */
export var getTenantDeprecatedConcept = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/deprecatedConcepts/").concat(conceptCode), method: 'get', params: params }, options);
};
/**
 * GET: Provides concept
 * @summary tenants/{tenant}/concepts/{conceptCode}
 */
export var getTenantConcept = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode), method: 'get', params: params }, options);
};
/**
 * Gets the concepts data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsRepository/concepts
 */
export var getTenantApplicationsMv7ModulesConceptsRepositoryConcepts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsRepository/concepts"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets the concepts hash codes data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsRepository/conceptsHashCodes
 */
export var getTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodes = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsRepository/conceptsHashCodes"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets the concepts labels data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsLabelsRepository/conceptsLabels
 */
export var getTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsLabelsRepository/conceptsLabels"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET - returns Concern Report Form localization labels.
 * @summary tenants/{tenant}/applications/concernReportForm/localization
 */
export var getTenantApplicationsConcernReportFormLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/concernReportForm/localization"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET - returns configuration for Concern Report Form
 * @summary tenants/{tenant}/applications/concernReportForm/configuration
 */
export var getTenantApplicationsConcernReportFormConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/concernReportForm/configuration"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Get consultant info localization
 * @summary consultantInfo/tenants/{tenant}/localization
 */
export var getConsultantInfoTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultantInfo/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * Gets the consultant titles localization.
 * @summary tenants/{tenant}/applications/businessapp/consultantTitlesLocalization
 */
export var getTenantApplicationsBusinessappConsultantTitlesLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/businessapp/consultantTitlesLocalization"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET: Returns metadata about contact details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/contactDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumContactDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/contactDetailsMetadata"),
        method: 'get',
    }, options);
};
/**
 * GET: Returns localization for all countries on market
 * @summary tenants/{tenant}/countries
 */
export var getTenantCountries = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/countries"), method: 'get', params: params }, options);
};
/**
 * GET - provides tenant culture settings
 * @summary tenants/{tenant}/culture
 */
export var getTenantCulture = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/culture"), method: 'get' }, options);
};
/**
 * GET: Returns metadata for customer confirmation endpoints
 * @summary tenants/{tenant}/customerConfirmationMetadata
 */
export var getTenantCustomerConfirmationMetadata = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/customerConfirmationMetadata"), method: 'get', params: params }, options);
};
/**
 * Gets all available document types
 * @summary tenants/{tenant}/documentTypes
 */
export var getTenantDocumentTypes = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/documentTypes"), method: 'get' }, options);
};
/**
 * GET: Localization for Downgrade application
 * @summary tenants/{tenant}/applications/downgrade/localization
 */
export var getTenantApplicationsDowngradeLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/downgrade/localization"), method: 'get', params: params }, options);
};
/**
 * Get Earnings app localization
 * @summary tenants/{tenant}/applications/earningsApp/localization
 */
export var getTenantApplicationsEarningsAppLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/earningsApp/localization"), method: 'get', params: params }, options);
};
/**
 * Gets the search results for specified iPaper url and query using internal iPaper api.
 * @summary tenants/{tenant}/eCatalogueSearchResults/{eCatalogueId}
 */
export var getTenantECatalogueSearchResult = function (client, tenant, eCatalogueId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/eCatalogueSearchResults/").concat(eCatalogueId), method: 'get', params: params }, options);
};
/**
 * Gets the structure of eCatalogue for given eCatalogue Id
Internally, the microservice calls the external service twice and then returns the data
 * @summary tenants/{tenant}/eCatalogueStructures/{eCatalogueId}
 */
export var getTenantECatalogueStructure = function (client, tenant, eCatalogueId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/eCatalogueStructures/").concat(eCatalogueId), method: 'get', params: params }, options);
};
/**
 * GET: Get editorial pages by query parameters.
 * @summary tenants/{tenant}/applications/editorial/editorialPages
 */
export var getTenantApplicationsEditorialEditorialPages = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/editorialPages"), method: 'get', params: params }, options);
};
/**
 * GET: Get editorial header by ids.
 * @summary tenants/{tenant}/applications/editorial/headers
 */
export var getTenantApplicationsEditorialHeaders = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/headers"), method: 'get', params: params }, options);
};
/**
 * GET: Get product box carousels by ids.
 * @summary tenants/{tenant}/applications/editorial/productBoxCarousels
 */
export var getTenantApplicationsEditorialProductBoxCarousels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/productBoxCarousels"), method: 'get', params: params }, options);
};
/**
 * GET: Get article carousels by ids.
 * @summary tenants/{tenant}/applications/editorial/articleCarousels
 */
export var getTenantApplicationsEditorialArticleCarousels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/articleCarousels"), method: 'get', params: params }, options);
};
/**
 * GET: Get olapics by ids.
 * @summary tenants/{tenant}/applications/editorial/olapics
 */
export var getTenantApplicationsEditorialOlapics = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/olapics"), method: 'get', params: params }, options);
};
/**
 * GET: Get banners by ids.
 * @summary tenants/{tenant}/applications/editorial/banners
 */
export var getTenantApplicationsEditorialBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/banners"), method: 'get', params: params }, options);
};
/**
 * GET: Get editorial landing pages by IDs.
 * @summary tenants/{tenant}/applications/editorial/landingPages
 */
export var getTenantApplicationsEditorialLandingPages = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/landingPages"), method: 'get', params: params }, options);
};
/**
 * GET: Get editorial pages relative to given collection of pages.
 * @summary tenants/{tenant}/applications/editorial/relatedEditorialPages
 */
export var getTenantApplicationsEditorialRelatedEditorialPages = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/editorial/relatedEditorialPages"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET: Gets mixed PLP content by id
 * @summary tenants/{tenant}/applications/editorial/mixedPlpContents/{contentItemId}
 */
export var getTenantApplicationsEditorialMixedPlpContent = function (client, tenant, contentItemId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/editorial/mixedPlpContents/").concat(contentItemId),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets collection of editorial articles of specific type, related to products.
 * @summary tenants/{tenant}/editorialArticles
 */
export var getTenantEditorialArticles = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/editorialArticles"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for EInvoice application
 * @summary tenants/{tenant}/applications/eInvoice/localization
 */
export var getTenantApplicationsEInvoiceLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/eInvoice/localization"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for EndCustomer Referral Discount application
 * @summary tenants/{tenant}/applications/endCustomerReferralDiscount/localization
 */
export var getTenantApplicationsEndCustomerReferralDiscountLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/endCustomerReferralDiscount/localization"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets identity server endpoints for communication with identity server (API, OAuth, OpenId)
 * @summary tenants/{tenant}/system/endpoints/identityServer
 */
export var getTenantSystemEndpointsIdentityServer = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/system/endpoints/identityServer"), method: 'get' }, options);
};
/**
 * Gets Online url for specific tenant. It could be used for redirects to oriflame pages
 * @summary tenants/{tenant}/system/endpoints/online
 */
export var getTenantSystemEndpointsOnline = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/system/endpoints/online"), method: 'get', params: params }, options);
};
/**
 * Gets external campaigns for given campaing urls
 * @summary tenants/{tenant}/applications/externalCampaignApp/externalCampaigns
 */
export var getTenantApplicationsExternalCampaignAppExternalCampaigns = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/externalCampaignApp/externalCampaigns"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET: Retrieves the metadata for external providers (FB, WeChat, VKontakte...)
 * @summary tenants/{tenant}/customerExternalProfilesMetadata
 */
export var getTenantCustomerExternalProfilesMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/customerExternalProfilesMetadata"), method: 'get' }, options);
};
/**
 * Gets feedback benefit banners
 * @summary tenants/{tenant}/applications/banner/feedbackBenefitBanners
 */
export var getTenantApplicationsBannerFeedbackBenefitBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/banner/feedbackBenefitBanners"), method: 'get', params: params }, options);
};
/**
 * Get footer
 * @summary tenants/{tenant}/applications/footer
 */
export var getTenantApplicationsFooter = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/footer"), method: 'get', params: params }, options);
};
/**
 * Gets collection of formatted price data for products
 * @summary tenants/{tenant}/productsFormattedPrices
 */
export var getTenantProductsFormattedPrices = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsFormattedPrices"), method: 'get', params: params }, options);
};
/**
 * Gets collection of formatted price data for concepts
 * @summary tenants/{tenant}/conceptsFormattedPrices
 */
export var getTenantConceptsFormattedPrices = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/conceptsFormattedPrices"), method: 'get', params: params }, options);
};
/**
 * GET - provides Product Standards.
 * @summary tenants/{tenant}/applications/frontPage/productStandards
 */
export var getTenantApplicationsFrontPageProductStandards = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/productStandards"), method: 'get', params: params }, options);
};
/**
 * GET - provides Motivation Content.
 * @summary tenants/{tenant}/applications/frontPage/motivationContent
 */
export var getTenantApplicationsFrontPageMotivationContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/motivationContent"), method: 'get', params: params }, options);
};
/**
 * GET - provides Beauty Edit section's data
 * @summary tenants/{tenant}/applications/frontPage/beautyEdit
 */
export var getTenantApplicationsFrontPageBeautyEdit = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/beautyEdit"), method: 'get', params: params }, options);
};
/**
 * GET - provides VIP Benefits section's data
 * @summary tenants/{tenant}/applications/frontPage/vipBenefits
 */
export var getTenantApplicationsFrontPageVipBenefits = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/vipBenefits"), method: 'get', params: params }, options);
};
/**
 * GET - provides Top Brands section's configuration
 * @summary tenants/{tenant}/applications/frontPage/topBrands
 */
export var getTenantApplicationsFrontPageTopBrands = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/topBrands"), method: 'get', params: params }, options);
};
/**
 * GET - provides Beauty Video data.
 * @summary tenants/{tenant}/applications/frontPage/beautyVideo
 */
export var getTenantApplicationsFrontPageBeautyVideo = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/beautyVideo"), method: 'get', params: params }, options);
};
/**
 * GET - provides content for the Benefit Banner.
 * @summary tenants/{tenant}/applications/frontPage/benefitBanner
 */
export var getTenantApplicationsFrontPageBenefitBanner = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/benefitBanner"), method: 'get', params: params }, options);
};
/**
 * GET - provides content for the Notification Banner.
 * @summary tenants/{tenant}/applications/frontPage/notificationBanner
 */
export var getTenantApplicationsFrontPageNotificationBanner = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/notificationBanner"), method: 'get', params: params }, options);
};
/**
 * GET - provides content for the FrontPage
 * @summary tenants/{tenant}/applications/frontPage
 */
export var getTenantApplicationsFrontPage = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage"), method: 'get', params: params }, options);
};
/**
 * Returns Genesys widget metadata
 * @summary tenants/{tenant}/applications/genesysWidget/metadata
 */
export var getTenantApplicationsGenesysWidgetMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/genesysWidget/metadata"), method: 'get' }, options);
};
/**
 * Returns Genesys widget page metadata
 * @summary tenants/{tenant}/applications/genesysWidget/pageMetadata
 */
export var getTenantApplicationsGenesysWidgetPageMetadata = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/genesysWidget/pageMetadata"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for guarantee credit application
 * @summary tenants/{tenant}/applications/guaranteeCredit/localization
 */
export var getTenantApplicationsGuaranteeCreditLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/guaranteeCredit/localization"), method: 'get', params: params }, options);
};
/**
 * GET: Configuration for guarantee credit application
 * @summary tenants/{tenant}/applications/guaranteeCredit/grantedCreditConfiguration
 */
export var getTenantApplicationsGuaranteeCreditGrantedCreditConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/guaranteeCredit/grantedCreditConfiguration"),
        method: 'get',
    }, options);
};
/**
 * Gets the mobile application homepage.
 * @summary tenants/{tenant}/applications/MV7/homepage
 */
export var getTenantApplicationsMV7Homepage = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/homepage"), method: 'get', params: params }, options);
};
/**
 * Return possible userSegment types
 * @summary tenants/{tenant}/applications/MV7/usersegmenttypes
 */
export var getTenantApplicationsMV7Usersegmenttypes = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/usersegmenttypes"), method: 'get', params: params }, options);
};
/**
 * Get social media library image info by imageInfoId
 * @summary tenants/{tenant}/socialMediaLibrary/imageInfos/{imageInfoId}
 */
export var getTenantSocialMediaLibraryImageInfo = function (client, tenant, imageInfoId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/socialMediaLibrary/imageInfos/").concat(imageInfoId),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Get social media library images
 * @summary tenants/{tenant}/socialMediaLibrary/imageInfos
 */
export var getTenantSocialMediaLibraryImageInfos = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/socialMediaLibrary/imageInfos"), method: 'get', params: params }, options);
};
/**
 * Get Incentives localizations
 * @summary tenants/{tenant}/applications/incentivesApp/localization
 */
export var getTenantApplicationsIncentivesAppLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/incentivesApp/localization"), method: 'get', params: params }, options);
};
/**
 * Gets collection of Ingredients for given ingredient Names. If collection of ingredients is empty
all ingredients are returned
 * @summary tenants/{tenant}/ingredients
 */
export var getTenantIngredients = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/ingredients"), method: 'get', params: params }, options);
};
/**
 * Gets Ingredient for given name
 * @summary tenants/{tenant}/ingredients/{ingredientName}
 */
export var getTenantIngredient = function (client, tenant, ingredientName, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/ingredients/").concat(ingredientName), method: 'get', params: params }, options);
};
/**
 * Gets the ingredients inspirations
 * @summary tenants/{tenant}/ingredientsInspirations
 */
export var getTenantIngredientsInspirations = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/ingredientsInspirations"), method: 'get', params: params }, options);
};
/**
 * Get Invite a friend configuration
 * @summary tenants/{tenant}/inviteFriendConfiguration
 */
export var getTenantInviteFriendConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/inviteFriendConfiguration"), method: 'get' }, options);
};
/**
 * Gets Invite a friend / end customer referral program profile for the customer with given consultant number
 * @summary tenants/{tenant}/inviteFriendLinks/{consultantNumber}
 */
export var getTenantInviteFriendLink = function (client, tenant, consultantNumber, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/inviteFriendLinks/").concat(consultantNumber), method: 'get' }, options);
};
/**
 * GET: Returns joining fee info and html content
 * @summary tenants/{tenant}/joiningFeeDialog/html
 */
export var getTenantJoiningFeeDialogHtml = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/joiningFeeDialog/html"), method: 'get' }, options);
};
/**
 * GET - returns language configuration for footer.
 * @summary tenants/{tenant}/applications/footer/languageConfiguration
 */
export var getTenantApplicationsFooterLanguageConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/footer/languageConfiguration"), method: 'get', params: params }, options);
};
/**
 * GET - returns collection of languages for footer.
 * @summary tenants/{tenant}/languages
 */
export var getTenantLanguages = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/languages"), method: 'get' }, options);
};
/**
 * GET: Returns metadata about legal details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/legalDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumLegalDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/legalDetailsMetadata"),
        method: 'get',
    }, options);
};
/**
 * GET: Localization strings.
 * @summary tenants/{tenant}/localizations/{id}
 */
export var getTenantLocalization = function (client, tenant, id, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/localizations/").concat(id), method: 'get', params: params }, options);
};
/**
 * Provides list of tenants for SharingApp
 * @summary applications/sharingApp/tenants
 */
export var getApplicationsSharingAppTenants = function (client, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/sharingApp/tenants", method: 'get' }, options);
};
/**
 * GET: Localization for login-sidebar component
 * @summary tenants/{tenant}/applications/loginSidebar/localization
 */
export var getTenantApplicationsLoginSidebarLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/loginSidebar/localization"), method: 'get' }, options);
};
/**
 * GET - Product Detail of Makeup Try On Configuration
 * @summary tenants/{tenant}/applications/makeupTryOn/configuration
 */
export var getTenantApplicationsMakeupTryOnConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/makeupTryOn/configuration"), method: 'get', params: params }, options);
};
/**
 * Gets products relations for given product codes
 * @summary tenants/{tenant}/applications/makeupTryOn/productsRelation
 */
export var getTenantApplicationsMakeupTryOnProductsRelation = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/makeupTryOn/productsRelation"), method: 'get', params: params }, options);
};
/**
 * Provides information about manager seminar parameters.
 * @summary tenants/{tenant}/commissionPlanTypes/successPlan/managerSeminarConfiguration
 */
export var getTenantCommissionPlanTypesSuccessPlanManagerSeminarConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/commissionPlanTypes/successPlan/managerSeminarConfiguration"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET: Localization for Member upgrade application
 * @summary tenants/{tenant}/applications/memberUpgrade/localization
 */
export var getTenantApplicationsMemberUpgradeLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/memberUpgrade/localization"), method: 'get' }, options);
};
/**
 * GET: Configuration for MiniBag SPA
 * @summary tenants/{tenant}/applications/miniBag/configuration
 */
export var getTenantApplicationsMiniBagConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/miniBag/configuration"), method: 'get' }, options);
};
/**
 * Gets the mobile apps.
 * @summary tenants/{tenant}/mobileApps
 */
export var getTenantMobileApps = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/mobileApps"), method: 'get', params: params }, options);
};
/**
 * Gets the mobile app download page header.
 * @summary tenants/{tenant}/applications/mobileApps/pageHeader
 */
export var getTenantApplicationsMobileAppsPageHeader = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mobileApps/pageHeader"), method: 'get', params: params }, options);
};
/**
 * Gets links for all existing mobile applications.
 * @summary tenants/{tenant}/mobileAppsLinks
 */
export var getTenantMobileAppsLinks = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/mobileAppsLinks"), method: 'get' }, options);
};
/**
 * Provides configuration for Mobile Office
 * @summary tenants/{tenant}/applications/mobileOffice/configuration
 */
export var getTenantApplicationsMobileOfficeConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mobileOffice/configuration"), method: 'get' }, options);
};
/**
 * Get My Business localization
 * @summary myBusiness/tenants/{tenant}/localization
 */
export var getMyBusinessTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/myBusiness/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * Get MyPages Dashboard localizations
 * @summary tenants/{tenant}/applications/mypagesDashboard/localization
 */
export var getTenantApplicationsMypagesDashboardLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mypagesDashboard/localization"), method: 'get', params: params }, options);
};
/**
 * Get category navigation tree or subtree.
 * @summary tenants/{tenant}/applications/MV7/navigationCategories/{category}
 */
export var getTenantApplicationsMV7NavigationCategory = function (client, tenant, category, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/navigationCategories/").concat(category),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Get brand navigation tree or subtree.
 * @summary tenants/{tenant}/applications/MV7/navigationBrands/{brand}
 */
export var getTenantApplicationsMV7NavigationBrand = function (client, tenant, brand, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/navigationBrands/").concat(brand), method: 'get', params: params }, options);
};
/**
 * Gets concept search results by the specified category.
 * @summary tenants/{tenant}/applications/MV7/navigationCategories/{category}/concepts
 */
export var getTenantApplicationsMV7NavigationCategoryConcepts = function (client, tenant, category, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/navigationCategories/").concat(category, "/concepts"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets concepts by the specified brand.
 * @summary tenants/{tenant}/applications/MV7/navigationBrands/{brand}/concepts
 */
export var getTenantApplicationsMV7NavigationBrandConcepts = function (client, tenant, brand, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/navigationBrands/").concat(brand, "/concepts"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets all concepts with optional filterParams filtering. Useful for root pages of sample-shop, outlet, etc.
 * @summary tenants/{tenant}/applications/MV7/modules/navigationGeneral/concepts
 */
export var getTenantApplicationsMV7ModulesNavigationGeneralConcepts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/modules/navigationGeneral/concepts"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Get navigation items for specific type
 * @summary tenants/{tenant}/applications/navigation/navigations/{navigationType}
 */
export var getTenantApplicationsNavigationNavigation = function (client, tenant, navigationType, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/navigation/navigations/").concat(navigationType),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Returns collection of tags for chosen related category
 * @summary tenants/{tenant}/navigationTags/{relatedCategory}
 */
export var getTenantNavigationTag = function (client, tenant, relatedCategory, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/navigationTags/").concat(relatedCategory), method: 'get', params: params }, options);
};
/**
 * GET - Returns Newsletter Subscription Configuration.
 * @summary tenants/{tenant}/applications/newsletterSubscription/Configuration
 */
export var getTenantApplicationsNewsletterSubscriptionConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/newsletterSubscription/Configuration"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Get Notification Web Client localization
 * @summary notifications/tenants/{tenant}/localization
 */
export var getNotificationsTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/notifications/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * GET: NovAge skincare advisor configuration.
 * @summary tenants/{tenant}/applications/advisor/novAgeSkincareConfiguration
 */
export var getTenantApplicationsAdvisorNovAgeSkincareConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/advisor/novAgeSkincareConfiguration"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET: NovAge skincare advisor localization.
 * @summary tenants/{tenant}/applications/advisor/novAgeSkincareLocalization
 */
export var getTenantApplicationsAdvisorNovAgeSkincareLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/advisor/novAgeSkincareLocalization"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Returns configurations for given olapic type and optional parameters.
 * @summary tenants/{tenant}/applications/olapic/configuration
 */
export var getTenantApplicationsOlapicConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/olapic/configuration"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for Onboarding application
 * @summary tenants/{tenant}/applications/onboarding/localization
 */
export var getTenantApplicationsOnboardingLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/onboarding/localization"), method: 'get' }, options);
};
/**
 * GET: Localization for Order History application
 * @summary tenants/{tenant}/applications/orderHistory/localization
 */
export var getTenantApplicationsOrderHistoryLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/orderHistory/localization"), method: 'get' }, options);
};
/**
 * GET: Returns meta information for specified pageId. Publicly cached for 10 minutes.
 * @summary tenants/{tenant}/pageMetaData
 */
export var getTenantPageMetaData = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/pageMetaData"), method: 'get', params: params }, options);
};
/**
 * GET current period information
 * @summary tenants/{tenant}/periods/currentPeriod
 */
export var getTenantPeriodsCurrentPeriod = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/periods/currentPeriod"), method: 'get' }, options);
};
/**
 * GET: Provides product permissions
 * @summary tenants/{tenant}/products/{productCode}/permission
 */
export var getTenantProductPermission = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/permission"), method: 'get', params: params }, options);
};
/**
 * GET: Provides concept permissions
 * @summary tenants/{tenant}/concepts/{conceptCode}/permission
 */
export var getTenantConceptPermission = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/permission"), method: 'get', params: params }, options);
};
/**
 * Get personal beauty store localization
 * @summary personalBeautyStore/tenants/{tenant}/localization
 */
export var getPersonalBeautyStoreTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalBeautyStore/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * GET: Returns metadata about personal details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/personalDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumPersonalDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/personalDetailsMetadata"),
        method: 'get',
    }, options);
};
/**
 * Get Personal Group Listing localization
 * @summary personalGroupListing/tenants/{tenant}/localization
 */
export var getPersonalGroupListingTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalGroupListing/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * Get Personal Group Overview localization
 * @summary personalGroupOverview/tenants/{tenant}/localization
 */
export var getPersonalGroupOverviewTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalGroupOverview/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * Get Personal Menu localization
 * @summary applications/personalMenu/tenants/{tenant}/localization
 */
export var getApplicationsPersonalMenuTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalMenu/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * GET: Returns options for telephone formatting
 * @summary tenants/{tenant}/phoneFormats
 */
export var getTenantPhoneFormats = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/phoneFormats"), method: 'get' }, options);
};
/**
 * GET: Provides information about product price
 * @summary tenants/{tenant}/products/{productCode}/price
 */
export var getTenantProductPrice = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/price"), method: 'get', params: params }, options);
};
/**
 * GET: Provides information about concept price
 * @summary tenants/{tenant}/concepts/{conceptCode}/price
 */
export var getTenantConceptPrice = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/price"), method: 'get', params: params }, options);
};
/**
 * Get product box
 * @summary tenants/{tenant}/applications/productBox
 */
export var getTenantApplicationsProductBox = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productBox"), method: 'get', params: params }, options);
};
/**
 * Gets single product bundle by product code
 * @summary tenants/{tenant}/productBundles/{productCode}
 */
export var getTenantProductBundle = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productBundles/").concat(productCode), method: 'get', params: params }, options);
};
/**
 * Gets collection of product bundles
 * @summary tenants/{tenant}/productBundles
 */
export var getTenantProductBundles = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productBundles"), method: 'get', params: params }, options);
};
/**
 * GET - Product Detail Configuration
 * @summary tenants/{tenant}/applications/productDetail/configuration
 */
export var getTenantApplicationsProductDetailConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productDetail/configuration"), method: 'get', params: params }, options);
};
/**
 * GET - Tooling banners for given products
 * @summary tenants/{tenant}/applications/productDetail/toolingBanners
 */
export var getTenantApplicationsProductDetailToolingBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productDetail/toolingBanners"), method: 'get', params: params }, options);
};
/**
 * Gets calculated attributes for producr from product index.
 * @summary tenants/{tenant}/productIndexItems
 */
export var getTenantProductIndexItems = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productIndexItems"), method: 'get', params: params }, options);
};
/**
 * GET: Provides collection of Product Labels' contents.
 * @summary tenants/{tenant}/productLabelsContent
 */
export var getTenantProductLabelsContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productLabelsContent"), method: 'get', params: params }, options);
};
/**
 * Get product listing with products and promo banners based on ID
 * @summary tenants/{tenant}/applications/MV7/productlistings
 */
export var getTenantApplicationsMV7Productlistings = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/productlistings"), method: 'get', params: params }, options);
};
/**
 * Provides product list link.
 * @summary tenants/{tenant}/productlists/{productListId}/dynamiclink
 */
export var getTenantProductlistDynamiclink = function (client, tenant, productListId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/productlists/").concat(productListId, "/dynamiclink"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET: Provides product
 * @summary tenants/{tenant}/deprecatedProducts/{productCode}
 */
export var getTenantDeprecatedProduct = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/deprecatedProducts/").concat(productCode), method: 'get', params: params }, options);
};
/**
 * Provides dynamic link to a single product.
 * @summary tenants/{tenant}/products/{productCode}/dynamiclink
 */
export var getTenantProductDynamiclink = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/dynamiclink"), method: 'get', params: params }, options);
};
/**
 * GET: Provides product from product service
 * @summary tenants/{tenant}/products/{productCode}
 */
export var getTenantProduct = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode), method: 'get', params: params }, options);
};
/**
 * Gets the product data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/products
 */
export var getTenantApplicationsMv7ModulesProductsRepositoryProducts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/products"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets the products hashcodes data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/productsHashCodes
 */
export var getTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodes = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/productsHashCodes"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets the products expected inbounds
 * @summary tenants/{tenant}/productsExpectedInbounds
 */
export var getTenantProductsExpectedInbounds = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsExpectedInbounds"), method: 'get', params: params }, options);
};
/**
 * Gets the products ingredients
 * @summary tenants/{tenant}/productsIngredients
 */
export var getTenantProductsIngredients = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsIngredients"), method: 'get', params: params }, options);
};
/**
 * Gets collection of product labels for anonymous customer.
 * @summary tenants/{tenant}/productsLabels
 */
export var getTenantProductsLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsLabels"), method: 'get', params: params }, options);
};
/**
 * Gets the products labels data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsLabelsRepository/productsLabels
 */
export var getTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsLabelsRepository/productsLabels"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets products manufacturers.
 * @summary tenants/{tenant}/productsManufacturers
 */
export var getTenantProductsManufacturers = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsManufacturers"), method: 'get', params: params }, options);
};
/**
 * Gets the products prices data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsPricesRepository/productsPrices
 */
export var getTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPrices = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsPricesRepository/productsPrices"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets products replacements for specific customer.
 * @summary tenants/{tenant}/productsReplacements
 */
export var getTenantProductsReplacements = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsReplacements"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for profile application
 * @summary tenants/{tenant}/applications/profile/localization
 */
export var getTenantApplicationsProfileLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/profile/localization"), method: 'get' }, options);
};
/**
 * @summary tenants/{tenant}/profileApprovalMetadata
 */
export var getTenantProfileApprovalMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/profileApprovalMetadata"), method: 'get' }, options);
};
/**
 * Gets best offers banners
 * @summary tenants/{tenant}/promotions/banners/bestoffers
 */
export var getTenantPromotionsBannersBestoffers = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/bestoffers"), method: 'get', params: params }, options);
};
/**
 * Gets whats new type banners
 * @summary tenants/{tenant}/promotions/banners/whatsnew
 */
export var getTenantPromotionsBannersWhatsnew = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/whatsnew"), method: 'get', params: params }, options);
};
/**
 * Gets hero banners
 * @summary tenants/{tenant}/promotions/banners/hero
 */
export var getTenantPromotionsBannersHero = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/hero"), method: 'get', params: params }, options);
};
/**
 * Gets campaign banners
 * @summary tenants/{tenant}/promotions/banners/campaign
 */
export var getTenantPromotionsBannersCampaign = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/campaign"), method: 'get', params: params }, options);
};
/**
 * Gets category banners
 * @summary tenants/{tenant}/promotions/banners/category
 */
export var getTenantPromotionsBannersCategory = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/category"), method: 'get', params: params }, options);
};
/**
 * Gets current promotions
 * @summary tenants/{tenant}/digitalPromotions
 */
export var getTenantDigitalPromotions = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/digitalPromotions"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for RealTime Order Tracking application
 * @summary tenants/{tenant}/applications/realTimeOrderTracking/localization
 */
export var getTenantApplicationsRealTimeOrderTrackingLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/realTimeOrderTracking/localization"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * GET: Get RealTimeOrderTracking
 * @summary tenants/{tenant}/realtimeOrderTrackings/{orderId}
 */
export var getTenantRealtimeOrderTracking = function (client, tenant, orderId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/realtimeOrderTrackings/").concat(orderId), method: 'get', params: params }, options);
};
/**
 * GET: Returns metadata about pre-step of registration
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/registrationsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumRegistrationsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/registrationsMetadata"),
        method: 'get',
    }, options);
};
/**
 * GET - Provides related product codes and relation types.
 * @summary tenants/{tenant}/products/{productCode}/relations
 */
export var getTenantProductRelations = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/relations"), method: 'get', params: params }, options);
};
/**
 * GET: Returns metadata for reports SPA
 * @summary tenants/{tenant}/applications/reportsSpa/metadata
 */
export var getTenantApplicationsReportsSpaMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/reportsSpa/metadata"), method: 'get' }, options);
};
/**
 * Dummy endpoint
 * @summary tenants/{tenant}/sample
 */
export var getTenantSample = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/sample"), method: 'get' }, options);
};
/**
 * Gets available facets for each category to use in search filters.
 * @summary tenants/{tenant}/applications/MV7/facetSettings
 */
export var getTenantApplicationsMV7FacetSettings = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/facetSettings"), method: 'get' }, options);
};
/**
 * GET: Localization for brand partner's simplified registration application
 * @summary tenants/{tenant}/applications/simplifiedRegistration/brandPartnerLocalization
 */
export var getTenantApplicationsSimplifiedRegistrationBrandPartnerLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/simplifiedRegistration/brandPartnerLocalization"),
        method: 'get',
    }, options);
};
/**
 * GET: Localization for VIP customer's simplified registration application
 * @summary tenants/{tenant}/applications/simplifiedRegistration/vipCustomerLocalization
 */
export var getTenantApplicationsSimplifiedRegistrationVipCustomerLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/simplifiedRegistration/vipCustomerLocalization"),
        method: 'get',
    }, options);
};
/**
 * GET - Returns collection of Social Media Links.
 * @summary tenants/{tenant}/socialMediaLinks
 */
export var getTenantSocialMediaLinks = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/socialMediaLinks"), method: 'get', params: params }, options);
};
/**
 * GET: Returns metadata about sponsor details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/sponsorDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumSponsorDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/sponsorDetailsMetadata"),
        method: 'get',
    }, options);
};
/**
 * @summary tenants/{tenant}/stepsToSuccessPhases
 */
export var getTenantStepsToSuccessPhases = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/stepsToSuccessPhases"), method: 'get', params: params }, options);
};
/**
 * Get Steps to success localization
 * @summary tenants/{tenant}/applications/stepsToSuccess/localization
 */
export var getTenantApplicationsStepsToSuccessLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/stepsToSuccess/localization"), method: 'get', params: params }, options);
};
/**
 * Returns all existing subscription types and their packages, including inactive ones.
 * @summary tenants/{tenant}/subscriptionTypes
 */
export var getTenantSubscriptionTypes = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/subscriptionTypes"), method: 'get' }, options);
};
/**
 * Gets benefit banners for products
 * @summary tenants/{tenant}/applications/banner/subscriptionBenefitBanners
 */
export var getTenantApplicationsBannerSubscriptionBenefitBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/banner/subscriptionBenefitBanners"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * @summary tenants/{tenant}/subscriptionReplacements
 */
export var getTenantSubscriptionReplacements = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/subscriptionReplacements"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for SubscriptionWizard application
 * @summary tenants/{tenant}/applications/subscriptionWizard/localization
 */
export var getTenantApplicationsSubscriptionWizardLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/subscriptionWizard/localization"),
        method: 'get',
        params: params,
    }, options);
};
/**
 * Gets the localization.
 * @summary applications/supportCenter/tenants/{tenant}/localization
 */
export var getApplicationsSupportCenterTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * gets tag groups
 * @summary tenants/{tenant}/tagGroups
 */
export var getTenantTagGroups = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/tagGroups"), method: 'get', params: params }, options);
};
/**
 * Get target list localization
 * @summary targetList/tenants/{tenant}/localization
 */
export var getTargetListTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/targetList/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * Returns terms info and html content
 * @summary tenants/{tenant}/terms/{termId}/html
 */
export var getTenantTermHtml = function (client, tenant, termId, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/terms/").concat(termId, "/html"), method: 'get' }, options);
};
/**
 * Ping
 * @summary test/tenants/{tenant}/ping
 */
export var getTestTenantPing = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/test/tenants/".concat(tenant, "/ping"), method: 'get' }, options);
};
/**
 * Ping with proxy to itself
 * @summary test/tenants/{tenant}/pingproxy
 */
export var getTestTenantPingproxy = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/test/tenants/".concat(tenant, "/pingproxy"), method: 'get' }, options);
};
/**
 * Get GTM, Google Analytics and OneTrust configuration
 * @summary tenants/{tenant}/thirdPartyConfiguration
 */
export var getTenantThirdPartyConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/thirdPartyConfiguration"), method: 'get', params: params }, options);
};
/**
 * Get title progress localization
 * @summary titleProgress/tenants/{tenant}/localization
 */
export var getTitleProgressTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/titleProgress/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
/**
 * GET - provides tenant translations
 * @deprecated
 * @summary tenants/{tenant}/translations
 */
export var getTenantTranslationsDeprecated = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/translations"), method: 'get', params: params }, options);
};
/**
 * GET - provides Vip Customer Banner content.
 * @summary tenants/{tenant}/vipCustomerBanner
 */
export var getTenantVipCustomerBanner = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/vipCustomerBanner"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for VipUpgrade application
 * @summary tenants/{tenant}/applications/vipUpgrade/localization
 */
export var getTenantApplicationsVipUpgradeLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/vipUpgrade/localization"), method: 'get' }, options);
};
/**
 * GET: Localization for Vouchers application
 * @summary tenants/{tenant}/applications/vouchers/localization
 */
export var getTenantApplicationsVouchersLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/vouchers/localization"), method: 'get', params: params }, options);
};
/**
 * GET: Localization for Wallet application
 * @summary tenants/{tenant}/applications/wallet/localization
 */
export var getTenantApplicationsWalletLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/wallet/localization"), method: 'get' }, options);
};
/**
 * Returns Web Messaging configuration
 * @summary tenants/{tenant}/applications/webMessenger/configuration
 */
export var getTenantApplicationsWebMessengerConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/webMessenger/configuration"), method: 'get', params: params }, options);
};
/**
 * Get wellnes club static image banners
 * @summary tenants/{tenant}/applications/WellnessClub/banners
 */
export var getTenantApplicationsWellnessClubBanners = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/WellnessClub/banners"), method: 'get' }, options);
};

//# sourceMappingURL=api.js.map
